'use strict';

customerZone.controller('LoginController', ['AuthenticationService', 'Session', 'config',
    'utils', '$log', '$location', 'errorCode', function(AuthenticationService, Session, config,
        utils, $log, $location, errorCode){
        var self = this;
        self.loginError = null;

        /** False in case the controller is not busy, a describing string (== true) in case it's doing something */
        self.busy = false;

        self.explanation = utils.translate($location.search()['explanation'], true);
        self.emailLoginOnly = $location.search()['emailLoginOnly'];

        // We don't use the generic busy util here, because we also want to be able to use this controller
        // on the sidebar, which requires a different styling.
        self.login = function(username, password){
            self.loginError = null;
            self.busy = utils.translate('log_in');

            return AuthenticationService.login(username, password)
                .then(function(){
                    self.busy = false;
                    self.user = Session.profile();
                    $log.debug('Logged in successfully');
                    redirect();
                })
                .catch(function(error){
                    self.busy = false;
                    if (errorCode.is(error, errorCode.LOGIN_BY_EMAIL_IMPOSSIBLE)) {
                        self.loginError = utils.translate('cannot_login_with_email_use_phone_instead');
                    }
                    else if (errorCode.is(error, errorCode.INVALID_GRANT)) {
                        self.loginError = utils.translate('incorrect_credentials_try_again');
                    }
                    else {
                        $log.error('Failed to log in: ', error);
                        utils.showError();
                    }
                });
        };

        var redirect = function() {
            var destination = $location.search()['destination'];

            if (isRelativePath() || isJimDestination()) {
                $log.debug('Now redirecting to ' + destination);
                utils.redirect(destination);
            }

            function isRelativePath() {
                return !/^\w+:/.test(destination);
            }

            function isJimDestination() {
                try {
                    var url = new URL(destination);
                    return (destination && /(^|\.)jimmobile.be$/.exec(url.hostname));
                }
                catch (e) {
                    $log.error('Failed to redirect to' + destination);
                    return false;
                }
            }
        };

        self.session = function(){
            return Session;
        };
    }]);
